import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Tab, Tabs } from '@mui/material';

import Card from 'components/Card';
import Field from 'components/Field';
import Translator from 'utils/enumTranslator';

import ObjectDescriptors from '../components/ObjectDescriptors';

import 'Modals/modals.scss';

const tabStyle = {
  border: 'none',
  color: '#d0d4d6',
  fontSize: 16,
  fontWeight: 600,
  textTransform: 'none',
  '&.Mui-selected': {
    color: '#6d8994',
    backgroundColor: '#f7f7f7',
  },
};

const AddressDetail = ({ object }) => {
  const [selectedTab, setSelectedTab] = useState(1);

  const renderConfig = () => {
    const category = Translator.category(object.category);
    const ipType = Translator.protocolType(object.type);

    return (
      <div className="modal__content padded new-address-survey">
        <Card header={false}>
          <div className="form-row">
            <Field.Group label="Name" extraClass="flex-3">
              <Field.Text extraClass="object-name" text={object.name} title={object.name} />
            </Field.Group>
            <Field.Group label={ipType.label} extraClass="flex-2">
              <Field.Text text={object.address} />
            </Field.Group>
          </div>
          <div className="form-row">
            <Field.Group label="Category">
              <Field.Text text={category.label} />
            </Field.Group>
          </div>
          <div className="form-row">
            <Field.Group>
              <Field.Text copy text={object.uuid} />
            </Field.Group>
          </div>
        </Card>
      </div>
    );
  };

  return (
    <Box id="object__tabs">
      <Tabs
        value={selectedTab}
        onChange={(_, value) => setSelectedTab(value)}
        sx={{
          border: 'none',
          px: { xs: 2, md: 5 },
          pt: 2,
          '& .MuiTabs-indicator': {
            backgroundColor: '#11AEFB',
          },
        }}
      >
        <Tab value={1} label="Configuration" className="object__tab" sx={tabStyle} />
        <Tab value={2} label="Descriptors" className="object__tab" sx={tabStyle} />
      </Tabs>
      {selectedTab === 1 && renderConfig()}
      {selectedTab === 2 && <ObjectDescriptors object={object} />}
    </Box>
  );
};

AddressDetail.propTypes = {
  object: PropTypes.object.isRequired,
};

export default AddressDetail;
